import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';
import { ReportRecipientProject } from '../models';


type AddFilterProjectAction = {
  type:    ActionType.AddFilterProject;
  project: ReportRecipientProject;
}


/**
 * Dispatch this action to add a filter project
 * @param project - the project to add
 */
export const addFilterProjectAction = (project: ReportRecipientProject): AddFilterProjectAction => ({
  type:    ActionType.AddFilterProject,
  project: project,
});


export const  addFilterProjectReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.AddFilterProject) {
    return state;
  }

  const action = incomingAction as AddFilterProjectAction;

  return R.assocPath(
    ['reportRecipientSelectedProjects', `${action.project.displayName}`],
    action.project,
    state,
  );
};
